import { Component, Inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { DatePipe } from '@angular/common';
import { UserData } from 'src/app/models/user.model';

@Component({
  selector: 'app-about-bottom-sheet',
  templateUrl: './about-bottom-sheet.component.html',
  styleUrls: ['./about-bottom-sheet.component.css'],
  providers: [DatePipe]
})
export class AboutBottomSheetComponent {
  userData: UserData;

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: { userData: UserData },
    private datePipe: DatePipe
  ) {
    this.userData = data.userData;
  }

  formatDate(date: any): string {
    return this.datePipe.transform(date, 'mediumDate') || '';
  }
}